import { doctorsEndpoint } from '../../../common/api.endPoints';
import { HttpService } from '../../../common/http.service';
import {
  DisclosureDoctor,
  DoctorRow,
  DoctorsResponse,
  DxClaim,
  RuleHit,
} from './types';

export async function fetchDoctors(
  applicationId: string,
  years?: number,
): Promise<DoctorsResponse> {
  const response = await HttpService.getInstance().get(
    doctorsEndpoint(applicationId, years),
  );

  if (response?.error) {
    throw new Error(response.error.message ?? 'Failed to fetch doctor info');
  }

  const body = (response?.parsedBody ?? {}) as {
    dx?: { ruleHits?: RuleHit[]; claims?: DxClaim[] };
    rx?: DoctorRow[];
    disclosure?: DisclosureDoctor[];
  };

  return {
    dx: {
      ruleHits: Array.isArray(body.dx?.ruleHits) ? body.dx!.ruleHits : [],
      claims: Array.isArray(body.dx?.claims) ? body.dx!.claims : [],
    },
    rx: Array.isArray(body.rx) ? body.rx : [],
    disclosure: Array.isArray(body.disclosure) ? body.disclosure : [],
  };
}
